import React from 'react';
import AppDropdown from '../AppDropdown';

export default function BankDetailsCard({ value = {}, onChange }) {
  const patch = (field, val) => {
    if (onChange) {
      onChange({ ...value, [field]: val });
    }
  };

  const typeOptions = [
    { value: 'Current', label: 'Current' },
    { value: 'Savings', label: 'Savings' },
    { value: 'Overdraft', label: 'Overdraft' }
  ];

  return (
    <div className="rounded-2xl border border-outline-variant/30 bg-surface-container-lowest overflow-hidden shadow-xs">
      {/* Header */}
      <div className="bg-surface-container-low/60 px-6 py-3 border-b border-outline-variant/25 text-sm font-bold text-on-surface">
        Bank A/c details
      </div>

      {/* Grid Inputs */}
      <div className="p-6 flex flex-col gap-4">
        
        {/* Bank */}
        <label className="grid grid-cols-12 gap-4 items-center">
          <span className="col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">Bank</span>
          <input
            type="text"
            value={value.bank || ''}
            onChange={(e) => patch('bank', e.target.value)}
            placeholder="Bank Name..."
            className="col-span-9 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
          />
        </label>

        {/* Branch */}
        <label className="grid grid-cols-12 gap-4 items-center">
          <span className="col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">Branch</span>
          <input
            type="text"
            value={value.branch || ''}
            onChange={(e) => patch('branch', e.target.value)}
            placeholder="Branch..."
            className="col-span-9 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
          />
        </label>

        {/* A/c No. */}
        <label className="grid grid-cols-12 gap-4 items-center">
          <span className="col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">A/c No.</span>
          <input
            type="text"
            value={value.acNo || ''}
            onChange={(e) => patch('acNo', e.target.value)}
            placeholder="Account Number..."
            className="col-span-9 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
          />
        </label>

        {/* MICR Co. */}
        <label className="grid grid-cols-12 gap-4 items-center">
          <span className="col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">MICR Co.</span>
          <input
            type="text"
            value={value.micrCo || ''}
            onChange={(e) => patch('micrCo', e.target.value)}
            placeholder="MICR Code..."
            className="col-span-9 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
          />
        </label>

        {/* IFSC Code & Type (Inline) */}
        <div className="grid grid-cols-12 gap-4 items-center">
          <span className="col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">IFSC Code</span>
          <div className="col-span-9 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              type="text"
              value={value.ifscCode || ''}
              onChange={(e) => patch('ifscCode', e.target.value)}
              placeholder="IFSC Code..."
              className="h-10 w-full rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
            <div className="flex items-center gap-3">
              <span className="text-xs font-black uppercase tracking-wider text-on-surface-variant whitespace-nowrap shrink-0">Type</span>
              <AppDropdown
                value={value.type || 'Current'}
                onChange={(val) => patch('type', val)}
                options={typeOptions}
                className="w-full"
                triggerClassName="h-10 bg-surface-container-low"
              />
            </div>
          </div>
        </div>

        {/* Min PDC */}
        <label className="grid grid-cols-12 gap-4 items-center">
          <span className="col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">Min PDC</span>
          <div className="col-span-9">
            <input
              type="number"
              value={value.minPdc ?? 0}
              onChange={(e) => patch('minPdc', parseInt(e.target.value) || 0)}
              placeholder="0"
              className="h-10 w-full sm:w-1/2 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </div>
        </label>

      </div>
    </div>
  );
}
